module.exports = __webpack_public_path__ + "img/Info-icon-lg-blue.866baf58.svg";